export default __webpack_public_path__ + "static/media/02.5a714fb2.jpg";